import {StyleSheet, Dimensions, Platform} from 'react-native';

const {width, height} = Dimensions.get('window');
const cardWidth = Platform.OS === 'web' ? 300 : (width * 280) / 375;

// Theme-aware styles factory (docs/DARK-MODE.md). Style-as-function entries
// (container) are preserved — the factory returns them closed over the
// theme's colors.
const makeStyles = colors =>
  StyleSheet.create({
    container: leftMargin => ({
      padding: 12,
      width: cardWidth,
      backgroundColor: colors.surface,
      marginLeft: leftMargin,
      borderRadius: 16,
      shadowRadius: 30,
      shadowColor: colors.shadow,
      shadowOffset: {height: 0, width: 0},
      shadowOpacity: 0.12,
    }),
    image: {
      width: cardWidth - 24,
      height: ((cardWidth - 24) * 160) / 256,
      borderRadius: 8,
      overflow: 'hidden',
      resizeMode: 'cover',
    },
    content: {
      // flex: 1,
      marginTop: 10,
      alignItems: 'flex-start',
    },
    tagContainer: {
      padding: 8,
      backgroundColor: colors.surface,
      borderRadius: 8,
      top: 8,
      left: 8,
      position: 'absolute',
    },
    applyFlex: {
      // flex: 1,
    },
  });

export default makeStyles;
